angular.module('cian.serp.item')
.controller('UserRatingCtrl', ["$scope", "close", "OfferService", function ($scope, close, OfferService) {
  $scope.toggleRating = function(rating) {
    OfferService.toggleRating($scope.offer, rating);
    close(true);
  };

  $scope.close = function() {
    close();
  };
}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.rating.js
// module id = 498
// module chunks = 0